module.exports = __webpack_public_path__ + "img/23_91.ddef79d3.png";